import * as React from 'react';

import {CogButton} from 'shells/button/cog-button/cog-button';
import {Dialog} from 'shells/dialog/dialog';
import {SelectMenu} from 'shells/select-menu/select-menu';

import styles from './dash-header.module.css';

type Props = {
    title: string;
    isConfigurable: boolean;
    onEdit?: () => void;
    onRemove?: () => void;
    onDeleteConfirm?: () => void;
    isDeleteConfirming?: boolean;
};

type State = {
    isConfigMenuOpen: boolean;
};

export class DashHeaderConfigButton extends React.Component<Props, State> {
    configButtonRef: HTMLElement | null | undefined;

    constructor(props: Props) {
        super(props);
        this.state = {
            isConfigMenuOpen: false,
        };
    }

    render() {
        // @ts-expect-error
        let menuOptions = [];
        if (this.props.isConfigurable) {
            // @ts-expect-error
            menuOptions = menuOptions.concat({
                label: 'Edit',
                handleSelect: this.props.onEdit,
            });
        }
        if (this.props.onRemove) {
            menuOptions = menuOptions.concat({
                label: 'Remove',
                style: {color: '#fa4a62'},
                handleSelect: this.props.onRemove,
            });
        }

        return (
            <div className={styles['config-button-container']}>
                <CogButton
                    onClick={this.handleMenuOpen}
                    // @ts-expect-error
                    getButtonRef={(ref) => {
                        this.configButtonRef = ref;
                    }}
                    size={24}
                />
                {this.state.isConfigMenuOpen && this.configButtonRef ? (
                    <SelectMenu
                        onClose={this.handleMenuClose}
                        anchor={this.configButtonRef}
                        location='bottom'
                        options={menuOptions}
                    />
                ) : undefined}
                {this.props.isDeleteConfirming ? (
                    <Dialog
                        anchor={this.configButtonRef}
                        location='bottom'
                        question={`Are you sure you want to remove ${this.props.title}?`}
                        onPrimary={this.props.onDeleteConfirm}
                        onSecondary={this.props.onRemove}
                    />
                ) : undefined}
            </div>
        );
    }

    handleMenuOpen = () => {
        this.setState({isConfigMenuOpen: true});
    };

    handleMenuClose = () => {
        this.setState({isConfigMenuOpen: false});
    };
}
